import { InputAdornment, Table, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useState } from "react";
import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";
import { IOrganization } from "./AddressableSetup.types";
import { AddressableSetupListWorkspaces } from "./AddressableSetup.ListWorkspaces";
import { maskCNPJ } from "./AddressableSetup.utils";

interface IProps {
  data: IOrganization[];
  refetchOrganizations: () => Promise<any>;
}

const Title = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: #191c1a;
`;

const Subtitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: #0f0f1e99;
`;

export const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #191c1a;
`;

export const PageSubtitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #0F0F1E99;
`;

export function AddressableSetupListClients({ data, refetchOrganizations }: IProps) {
  const [selectedOrganization, setSelectedOrganization] = useState<IOrganization | null>(null);

  function handleRemoveOrganization() {
    setSelectedOrganization(null);
  }

  function updateSelectedOrganization(organizationId: string, updatedData?: IOrganization[]) {
    // Se updatedData foi fornecido, usa ele; caso contrário, usa o data atual
    const dataToSearch = updatedData || data;
    const updatedOrganization = dataToSearch.find(org => org.id === organizationId);
    if (updatedOrganization) {
      setSelectedOrganization(updatedOrganization);
    }
  }

  return (
    <>
      {!selectedOrganization ? (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
            <PageTitle>Endereçabilidade</PageTitle>
            <PageSubtitle>Crie grupos e defina quais cargos ou regiões pertencem a cada workspace</PageSubtitle>
          </div>
          <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
            <Table>
              <TableRow style={{ height: '70px'}}>
                <TableCell style={{ width: "500px"}}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                    Cliente
                  </span>
                </TableCell>
                <TableCell style={{ width: "60%"}}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                    Grupos criados
                  </span>
                </TableCell>
              </TableRow>
              {data.map((org, i) => (
                <TableRow key={org.id + i} style={{ height: '70px', cursor: "pointer" }} onClick={() => setSelectedOrganization(org)}>
                  <TableCell>
                    <div style={{display: "flex", flexDirection: "column"}}>
                      <Title>{org.corporateName}</Title>
                      <Subtitle>{maskCNPJ(org.federalTaxId)}</Subtitle>
                    </div>
                  </TableCell>
                  <TableCell>{org.workspaceAddressableParams.length}</TableCell>
                </TableRow>
              ))}
            </Table>
          </TableContainer>
        </>
      ) : (
        <AddressableSetupListWorkspaces
          data={selectedOrganization}
          handleRemoveOrganization={handleRemoveOrganization}
          refetchOrganizations={refetchOrganizations}
          updateSelectedOrganization={updateSelectedOrganization}
        />
      )}
    </>
  );
}
